import { useFetch } from "hooks/api";
import { useMemo } from "react";
import { useParams } from "react-router";

const useDSPSellerInfo = () => {
  // get seller id from url
  const { dspAdvertiser: dspAdvertiserId } = useParams();
  const { data: dspAdvertisers, isLoading } = useFetch(
    ["dspSellerInfo"],
    "/dsp/dsp_seller_info/",
    {},
    {
      select: (d) => d.data,
      default: [],
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  const dspAdvertiser = useMemo(() => {
    return dspAdvertisers?.find((profile) => profile.id.toString() === dspAdvertiserId) || null;
  }, [dspAdvertiserId, dspAdvertisers]);

  return {
    dspAdvertiser,
    dspAdvertisers,
    isLoading,
  };
};

export default useDSPSellerInfo;
